import React, { Component } from "react";
import Layout from "../../../componentes/Comunes/Layout/Layout";
import {
  Notificar,
  CerrarNotificador,
} from "../../../componentes/Comunes/Notificador";
import ParametroDetalleSolicitud from "../../../Contenedores/Padron/ParametroDetalleSolicitud";
import ServicioSolicitudPadron from "../../../servicios/SolicitudDePadron";
import Identificacion from "../../../Contenedores/Comun/Identificacion";
import TipoPersona from "../../../Contenedores/Comun/TipoPersona";
import { __EsPersonaJuridica } from "../../../Utils/Funciones";
import { withRouter } from "react-router-dom";
import DatosUsuario from "../../../componentes/Comunes/DatosUsuario/DatosUsuario";
import DatosValidacion from "../../../componentes/Padron/ComponenteDetalleSolicitud/DatosValidacion";
import Documentos from "../../../componentes/Padron/ComponenteDetalleSolicitud/Documentos";
import IdentificacionesAsociadas from "../../../componentes/Comunes/IdentificacionesAsociadas/IdentificacionesAsociadas";
import PersonaSugef from "../../../componentes/Padron/ComponenteDetalleSolicitud/PersonaSugef";
import PersonaEntidad from "../../../componentes/Padron/ComponenteDetalleSolicitud/PersonaEntidad";
import EncabezadoSolicitud from "../../../componentes/Padron/ComponenteDetalleSolicitud/EncabezadoSolicitud";
import { __ValidaEsRechazo } from "../../../Utils/FuncionesSolicitudPadron";
import servicioUsuario from "../../../servicios/servicioUsuario";
import { nombreDeRol } from "../../../constantes/nombreDeRol";
import { SOLICITUD_PENDIENTE_VALIDACION } from "../../../Contenedores/Comun/VARIABLES";
import { ParametrosActualizaSolicitud } from "../../../Contenedores/Padron/ParametroActualizaSolicitud";
import StickyTopBox from "../../../componentes/Comunes/StickyBox/StickyTopBox";

export class DetalleSolicitudPadron extends Component {
  constructor(props) {
    super(props);
    this.state = {
      EsValido: false,
      encabezado: [],
      personaEntidad: [],
      personaSugef: [],
      identificacionesAsociadas: [],
      documentos: [],
      documentosActualizados: false,
      EsVisiblePersonaFisica: false,
      usuarioSolicitante: [],
      datosValidacion: [],
      esTipoRechazo: false,
      EsEditablePersona: false,
      SolicitudPendienteValidacion: false,
      RenderizarDetalle: false,
    };
    this._EditarPendienteValidacion =
      this._EditarPendienteValidacion.bind(this);
    this.salirDeModoEdicion = this.salirDeModoEdicion.bind(this);
    this.RetornarPaginaConsulta = this.RetornarPaginaConsulta.bind(this);
  }

  async componentDidMount() {
    await this.cargarPantalla();
  }

  cargarPantalla = async () => {
    if (
      this.props.location.state?.Datos !== null &&
      this.props.location.state?.Datos !== undefined
    ) {
      let datos = this.props.location.state.Datos;
      let parametro = new ParametroDetalleSolicitud();
      parametro.Consecutivo = datos.consecutivo;
      parametro.IdPersonaTramite = new Identificacion();
      parametro.IdPersonaTramite.Codigo = datos.idPersonaTramite.codigo;
      parametro.IdPersonaTramite.TipoPersona = new TipoPersona();
      parametro.IdPersonaTramite.TipoPersona.Codigo =
        datos.idPersonaTramite.tipoPersona.codigo;

      let resultado =
        await ServicioSolicitudPadron.ObtengaDetalleSolicitudPadron(parametro);
      resultado.EsValido
        ? await this.CargarElementos(resultado)
        : Notificar("error", resultado.Errores);
    } else {
      Notificar(
        "error",
        "Ha ocurrido un error al cargar el detalle de la solicitud"
      );
    }
  };

  async CargarElementos(datos) {
    let identificaciones =
      datos.Solicitud.identificacionesAsociadasPersona.length > 0
        ? datos.Solicitud.identificacionesAsociadasPersona
        : null;
    let PersonaEntidad = datos.Solicitud.personaEntidad ?? null;
    let PersonaSUGEF = datos.Solicitud.personaSUGEF ?? null;
    let Documentos =
      datos.Solicitud.documentos.length > 0 ? datos.Solicitud.documentos : null;
    let VisiblePersonaFisica = await __EsPersonaJuridica(
      datos.Solicitud.idPersonaTramite.tipoPersona.codigo
    );
    let EsTipoRechazo = await __ValidaEsRechazo(datos.Solicitud.validacion);
    let UsuarioSolicitante = datos.Solicitud.usuarioSolicitante ?? null;
    let DatosValidacion =
      datos.Solicitud.validacion.usuarioValida === null
        ? null
        : datos.Solicitud.validacion;

    let tieneRolTramitarSolicitudes = servicioUsuario.tieneRol(
      nombreDeRol.PadronTramitarSolicitudes
    );
    let EsSolicitudPendienteValidacion = false;

    if (tieneRolTramitarSolicitudes) {
      EsSolicitudPendienteValidacion =
        datos.Solicitud.estadoSolicitud.id === SOLICITUD_PENDIENTE_VALIDACION
          ? true
          : false;
    }

    this.setState({
      EsValido: datos.EsValido,
      encabezado: datos.Solicitud,
      personaEntidad: PersonaEntidad,
      personaSugef: PersonaSUGEF,
      identificacionesAsociadas: identificaciones,
      documentos: Documentos,
      EsVisiblePersonaFisica: VisiblePersonaFisica,
      usuarioSolicitante: UsuarioSolicitante,
      datosValidacion: DatosValidacion,
      esTipoRechazo: EsTipoRechazo,
      SolicitudPendienteValidacion: EsSolicitudPendienteValidacion,
      RenderizarDetalle: true,
    });
  }

  async ReiniciarEstados() {
    this.setState({
      EsValido: false,
      personaEntidad: [],
      documentos: [],
      EsVisiblePersonaFisica: false,
      EsEditablePersona: false,
      SolicitudPendienteValidacion: false,
    });
  }

  async _EditarPendienteValidacion() {
    this.setState({
      EsEditablePersona: true,
    });

    CerrarNotificador();
  }

  async EsActualizacionCorrecta(solicitud) {
    if (solicitud.esValido) {
      this.setState({
        EsEditablePersona: false,
      });
      await this.salirDeModoEdicion();
      Notificar("success", solicitud.mensaje);
    } else {
      this.setState({
        EsEditablePersona: true,
      });
      Notificar("error", solicitud.errores);
    }
  }

  async salirDeModoEdicion() {
    await this.ReiniciarEstados();
    await this.cargarPantalla();
  }

  ObtengaInformaciondeMemoria() {
    let parametros = localStorage.getItem("parametrosCargadosSolicitud");
    return parametros;
  }

  ActualizarSolicitud = async () => {
    let datos = this.state.personaEntidad;
    let datosSolicitud = this.state.encabezado;
    let parametro = new ParametrosActualizaSolicitud();
    parametro.Solicitud = datosSolicitud.consecutivo;
    parametro.IdPersonaTramite.Codigo = datos.identificacionPrincipal.codigo;
    parametro.IdPersonaTramite.TipoPersona.Codigo =
      datos.identificacionPrincipal.tipoPersona.codigo;
    parametro.NombreORazonSocial = datos.NombreORazonSocial;
    parametro.PrimerApellido = datos.PrimerApellido;
    parametro.SegundoApellido = datos.SegundoApellido;
    parametro.Genero = datos.Genero;
    parametro.PaisNacORegistro = datos.paisRegistroONacimiento.codigoPais;
    parametro.FechaNacORegistro = datos.FechaConstitucionONacimiento;
    parametro.ListaDocumentos = this.state.documentosActualizados
      ? this.state.documentos
      : [];

    let resultado = await ServicioSolicitudPadron.ActualizarSolicitudPadron(
      parametro
    );
    await this.EsActualizacionCorrecta(resultado);
  };

  onChangePersonaEntidad = (personaEntidad) => {
    this.setState({ personaEntidad: personaEntidad });
  };

  onChangeDocumentos = (documentos) => {
    this.setState({
      documentos: documentos,
      documentosActualizados: true,
    });
  };

  async RetornarPaginaConsulta() {
    this.props.history.push({
      pathname: "/Padron/ConsultaSolicitudesPadron",
      state: {
        ParametrosCargados: this.ObtengaInformaciondeMemoria(),
      },
    });
  }

  render() {
    return (
      <Layout>
        <div>
          {this.state.RenderizarDetalle ? (
            <>
              <StickyTopBox>
                <div className="row">
                  <div className="col-auto">
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => this.RetornarPaginaConsulta()}
                    >
                      <i className="fas fa-arrow-circle-left"></i>
                    </button>
                  </div>
                  <div className="col">
                    <h1 className="h3 mb-0 text-gray-800">
                      Detalle de la Solicitud
                    </h1>
                  </div>
                  <div className="col">
                    <div className="text-right">
                      {this.state.SolicitudPendienteValidacion ? (
                        <button
                          onClick={
                            !this.state.EsEditablePersona
                              ? this._EditarPendienteValidacion
                              : this.ActualizarSolicitud
                          }
                          className="btn btn-success btn-icon-split mr-3"
                        >
                          <span className="icon text-white-50">
                            <i className="far fa-check-circle"></i>
                          </span>
                          <span className="text">
                            {!this.state.EsEditablePersona
                              ? "Editar"
                              : "Actualizar"}
                          </span>
                        </button>
                      ) : null}
                      {this.state.EsEditablePersona ? (
                        <button
                          type="button"
                          onClick={this.salirDeModoEdicion}
                          className="btn btn-danger btn-icon-split"
                        >
                          <span className="icon text-white-50">
                            <i className="far fa-times-circle"></i>
                          </span>
                          <span className="text">Cancelar</span>
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
              </StickyTopBox>
              {this.state.EsValido ? (
                <EncabezadoSolicitud Encabezado={this.state.encabezado} />
              ) : null}
              <div className="card-deck">
                {this.state.EsValido && this.state.personaEntidad != null ? (
                  <PersonaEntidad
                    Titulo={"Datos de la Persona Registrados por la Entidad"}
                    PersonaEntidad={this.state.personaEntidad}
                    EsEditable={this.state.EsEditablePersona}
                    VisiblePersonafisica={this.state.EsVisiblePersonaFisica}
                    onChangePersonaEntidad={this.onChangePersonaEntidad}
                  />
                ) : null}
                {this.state.EsValido && this.state.personaSugef != null ? (
                  <PersonaSugef
                    Titulo={"Datos de la Persona Registrados en SUGEF"}
                    PersonaSugef={this.state.personaSugef}
                    PersonaEntidad={this.state.personaEntidad}
                    VisiblePersonafisica={this.state.EsVisiblePersonaFisica}
                  />
                ) : null}
              </div>
              <div>
                {this.state.EsValido &&
                this.state.identificacionesAsociadas != null ? (
                  <IdentificacionesAsociadas
                    Identificaciones={this.state.identificacionesAsociadas}
                    Titulo={"Identificaciones Asociadas"}
                  />
                ) : null}
                {this.state.EsValido && this.state.documentos != null ? (
                  <Documentos
                    Documentos={this.state.documentos}
                    EsEditable={this.state.EsEditablePersona}
                    onChangeDocumentos={this.onChangeDocumentos}
                  />
                ) : null}
                {this.state.EsValido && this.state.datosValidacion != null ? (
                  <DatosValidacion
                    DatosValidacion={this.state.datosValidacion}
                    EsRechazo={this.state.esTipoRechazo}
                  />
                ) : null}
                {this.state.EsValido &&
                this.state.usuarioSolicitante != null ? (
                  <DatosUsuario
                    Usuario={this.state.usuarioSolicitante}
                    Titulo={"Datos del Usuario Solicitante"}
                  />
                ) : null}
              </div>
            </>
          ) : null}
        </div>
      </Layout>
    );
  }
}
export default withRouter(DetalleSolicitudPadron);
